import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { useApiDefaults } from 'hooks/useApiDefaults';
import "./center-card.scss";
import useStoreList from 'hooks/useStoreList';

const CenterImage = ({ section }) => {
  const { storeListData } = useStoreList();
  const storeList = storeListData?.filter(s => s.text_signup_form_key)
  const [selectedStore, setSelectedStore] = useState()

  const location = useLocation()
  const {RSAClientId} = useApiDefaults()

  const showIframe = location?.pathname === "/custom-pages/text-sign-up" && +RSAClientId === 323
  
  return (
    <div className='container content'>
      <div className='flex-container'>
        <h1>{section ? section.highlight_title : ''}</h1>
      </div>
      <div style={{ boxSizing: "border-box", margin: "0 auto", padding: 0, marginBottom: "100px", overflowX: "hidden", color: "#4d4d4f", fontFamily: "Raleway, sans-serif", fontSize: "18px" }}>
      <div style={{ boxSizing: "border-box", padding: "0 0", position: "relative",  margin: "auto", borderRadius: "15px" }}>
      {/* <br></br> */}
      {section.image !== '' ? (
        <>
          <div className='flex-container'>
            {section.click_on_image_redirect_url ? (
              <a
                href={section.click_on_image_redirect_url}
                target='_blank'
                rel='noreferrer'
              >
                <img
                  src={section ? section.image : ''}
                  alt='AboutImage'
                  className='center-align-image'
                />
              </a>
            ) : (
              <img
                src={section ? section.image : ''}
                alt='AboutImage'
                className='center-align-image'
              />
            )}
          </div>
          <br></br>
        </>
      ) : (
        ''
      )}

      {showIframe ? <div className="Stote-list-wrap" style={{maxWidth: "800px"}}>
      <div className='store-list'>
        <select
          value={selectedStore}
          onChange={e => setSelectedStore(e.target.value)}
        >
          <option value="">Select a Store</option>
          {storeList?.map(s => (
            <option value={s.text_signup_form_key}>{s.ClientStoreName}</option>
          ))}
        </select>
      </div>

      {selectedStore ? <div className="iframe-container" style={{ boxSizing: "border-box", margin: "0 auto", textAlign: "center", maxWidth: "100%", overflow: "auto" }}>
        <iframe src={selectedStore} style={{ boxSizing: 'border-box', width: '100%', maxWidth: '410px', height: '590px', border: 'none',
    }}/>
      </div>: null}
      </div> :      
      <p className="iframe-item"  dangerouslySetInnerHTML={{ 
          __html: section ? section.content : "",
        }}
      >
        {}
      </p>}
    </div>
    </div>
        </div>
    )
};

export default CenterImage;
